import { reportsChartRetrieveOptions } from '@crm/api'
import { useQuery } from '@tanstack/react-query'

import * as charts from './charts'
import { ChartTypes } from './types'

const chartsMapping = {
  [ChartTypes.PIE]: charts.PieChart,
  [ChartTypes.BAR]: charts.BarChart,
  [ChartTypes.LINE]: charts.LineChart,
  [ChartTypes.FUNNEL]: charts.FunnelChart
}

type Props = {
  chartType: ChartTypes
  label?: string
  id?: string
  xAxy?: string
  yAxy?: string
}

export const DynamicChart = ({ chartType, label, id, xAxy, yAxy }: Props) => {
  const Component = chartsMapping[chartType]

  const { data, isLoading } = useQuery(
    reportsChartRetrieveOptions({
      path: {
        id: Number(id)
      }
    })
  )

  return (
    <Component
      label={label}
      data={data}
      isLoading={isLoading}
      xAxy={xAxy}
      yAxy={yAxy}
    />
  )
}
